





























































































































































































































































import { Component, Vue, Mixins, Watch, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { ModelListSelect } from 'vue-search-select';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import TimesheetValidator from './TimesheetValidator';
@Component({
  components: {
    ModelListSelect,
    Datepicker,
  },
})
export default class TimesheetEntry extends Mixins(TimesheetValidator) {
  $moment: any;
  $wlToastr: any;
  private selectedCompany: any = {};
  private selectedJob: any = {};
  private weekStart: any = '';
  private endDate = '';
  private selectedWeek: Array<any> = [];
  private workedHours = 0;
  private offHours = 0;
  private projectCode = '';
  private comment = '';
  private jobLocation = '';
  private status = '';

  @Prop({ default: '' }) tabName;

  mounted() {
    vxm.timesheet.fetchChildCompanies();
  }

  canShowModal(event) {
    if (!vxm.timesheet.ChildCompanies.length) {
      this.$wlToastr('error', 'You are not hired for any job', 'Timesheet');
      event.preventDefault();
    }
  }
  
  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get addOrEditSavedTimesheet() {
    return this.status === 'Saved' || !vxm.timesheet.EditTimeSheetId;
  }

  @Watch('selectedCompany')
  async onChangeCompany(val) {
    const selectedCompany = this.childCompanies.find(
      (company) => company.companyId === val,
    );
    if (selectedCompany) {
      await vxm.timesheet.fetchJobList(selectedCompany.companyCode);
      !this.jobList.length &&
        this.$wlToastr('error', 'You are not hired for any job', 'Timesheet');
    }
  }

  @Watch('selectedJob')
  onChangeJob() {
    const job = this.jobList.find(
      (job) => job.jobPostingId === this.selectedJob,
    );
    this.jobLocation = job ? job.facilityName : '';
  }

  onFocusOutSampleHour() {
    this.validateSampleHourField({
      workedHours: this.workedHours,
      offHours: this.offHours,
    });
  }

  onFocusOutDayHour() {
    this.validateDayHourField({ selectedWeek: this.selectedWeek });
  }

  onOpenModal() {
    this.resetErrors();
    this.setTimeSheetDetails();
  }
  setTimeSheetDetails() {
    const id = vxm.timesheet.EditTimeSheetId;
    const timeSheetDetails = vxm.timesheet.CandidateTimeSheets.find(
      (timesheet) => timesheet.candidateTimeSheetId === id,
    );
    if (id && timeSheetDetails) {
      this.selectedCompany = timeSheetDetails.companyId;
      this.selectedJob = timeSheetDetails.jobPostingId;
      this.weekStart = new Date(
        vxm.utility.convertUTCToLocalTime(timeSheetDetails.timeSheetStartDate),
      );
      this.onSelectMonday(
        this.weekStart,
        timeSheetDetails.candidateTimeSheetDetails,
      );
      this.projectCode = timeSheetDetails.projectCode;
      this.comment = timeSheetDetails.userComments;
      this.jobLocation = timeSheetDetails.facilityName;
      this.status = timeSheetDetails.status;
      this.workedHours = 0;
      this.offHours = 0;
    } else {
      this.selectedCompany = '';
      this.selectedJob = '';
      this.weekStart = '';
      this.projectCode = '';
      this.comment = '';
      this.workedHours = 0;
      this.offHours = 0;
      this.jobLocation = '';
      this.selectedWeek = [];
      this.endDate = '';
    }
  }
  get appTheme() {
    return vxm.utility.AppTheme;
  }
  get childCompanies() {
    return vxm.timesheet.ChildCompanies;
  }
  get jobList() {
    return vxm.timesheet.JobList;
  }
  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }
  get totalWorkedHours() {
    const total = this.selectedWeek.reduce(
      (total, day) => (total += Number(day.workedHours)),
      0,
    );
    return Math.round(total * 10) / 10;
  }
  get totalOffHours() {
    const total = this.selectedWeek.reduce(
      (total, day) => (total += Number(day.offHours)),
      0,
    );
    return Math.round(total * 10) / 10;
  }
  onSelectMonday(date, details) {
    this.endDate = this.$moment(date).add(6, 'days')._d;
    this.selectedWeek = [];
    let i = 0;
    while (i < 7) {
      this.selectedWeek.push({
        date: this.$moment(date).add(i, 'days')._d,
        workedHours: details ? details[i].workedHours : 0,
        offHours: details ? details[i].timeOffHours : 0,
      });
      i++;
    }
  }

  applyToAllDays() {
    if (this.errors.totalSampleHours) {
      return;
    }
    this.selectedWeek.forEach((day) => {
      day.workedHours = this.workedHours;
      day.offHours = this.offHours;
      day.error = '';
    });
  }
  async saveTimesheet(action) {
    const selectedJob = this.jobList.find(
      (job) => job.jobPostingId === this.selectedJob,
    );
    const facilityId = selectedJob ? selectedJob.facilityId : 0;
    const editId = vxm.timesheet.EditTimeSheetId;
    const timeSheetDetails = vxm.timesheet.CandidateTimeSheets.find(
      (timesheet) => timesheet.candidateTimeSheetId === editId,
    );
    if (
      this.validateTimesheet({
        selectedCompany: this.selectedCompany,
        selectedJob: this.selectedJob,
        weekStart: this.weekStart,
        selectedWeek: this.selectedWeek,
      })
    ) {
      const payload = {
        action,
        candidateTimeSheetId: editId,
        companyId: this.selectedCompany,
        jobPostingId: this.selectedJob,
        facilityId,
        timeSheetStartDate: vxm.utility.convertLocalTimeToUTC(this.weekStart),
        timeSheetEndDate: vxm.utility.convertLocalTimeToUTC(this.endDate),
        projectCode: this.projectCode,
        totalWorkedHours: this.totalWorkedHours,
        totalTimeOffHours: this.totalOffHours,
        totalOverTimeHours: 0,
        userComments: this.comment,
        candidateTimeSheetDetails: this.selectedWeek.map((day, index) => {
          return {
            candidateTimeSheetDetailId:
              editId && timeSheetDetails
                ? timeSheetDetails.candidateTimeSheetDetails[index]
                    .candidateTimeSheetDetailId
                : 0,
            candidateTimeSheetId: editId,
            workDayDate: vxm.utility.convertLocalTimeToUTC(day.date),
            workedHours: day.workedHours,
            timeOffHours: day.offHours,
            overTimeHours: 0,
            userComments: '',
            adminComments: '',
          };
        }),
      };
      let resp;
      try {
        if (editId) {
          resp = await vxm.timesheet.editTimesheet(payload);
        } else {
          resp = await vxm.timesheet.saveTimesheet(payload);
        }
        if (resp.meta.success) {
          this.$bvModal.hide('timesheet-entry-modal');
          vxm.timesheet.fetchCandidateTimeSheets(this.tabName);
          //change msg
          this.$wlToastr(
            'success',
            `Timesheet  ${editId ? 'updated' : 'saved'}`,
            'Timesheet',
          );
        } else {
          let message = `Error in ${editId ? 'updated' : 'saved'}`;

          if (resp.meta && resp.meta.error && resp.meta.error.detailedMessage) {
            message = resp.meta.error.detailedMessage;
          }
          this.$wlToastr('error', message, 'Timesheet');
        }
      } catch (e) {
        const message = e.response.data.meta.error.detailedMessage;
        this.$wlToastr('error', message, 'Timesheet');
      }
    }
  }
}
